import { z } from 'zod'

import { randomAccessGroupSlug } from '@scalar-org/random-slug'

import { emailSchema, entitySchema, scalarSet, slugSchema } from '@/utility'

/** Adapted from Zod email regex - https://github.com/colinhacks/zod/blob/main/src/types.ts */
export const emailDomainRegex =
  /^([A-Za-z0-9]+(-[A-Za-z0-9]+)*\.)+[A-Za-z]{2,}$/i

/** Email domain validation with refine */
export const emailDomainSchema = z
  .string()
  .regex(emailDomainRegex, 'Invalid domain')
  // FQDN max length
  .max(253)
  .meta({ id: 'email-domain' })

export const accessGroupEmails = scalarSet(
  z
    .set(emailSchema)
    // Can be increased but setting a reasonable amount
    .max(1000, 'You can only add up to 1000 emails'),
)

export const accessGroupDomains = scalarSet(
  z
    .set(emailDomainSchema)
    // Can be increased but setting a reasonable amount
    .max(1000, 'You can only add up to 1000 domains'),
)

export const accessGroupNameSchema = z
  .string()
  .max(40)
  .meta({ id: 'access-group-name' })

/** Access Groups Schema */
export const accessGroupSchema = entitySchema
  .extend({
    name: accessGroupNameSchema.default(''),
    slug: slugSchema
      .default(randomAccessGroupSlug)
      .meta({ default: 'randomAccessGroupSlug()' }),
    /** Set of allowed external email addresses */
    allowedEmails: accessGroupEmails.default([]),
    /** List of allowed email domains */
    allowedDomains: accessGroupDomains.default([]),
  })
  .meta({ id: 'access-group' })

export type AccessGroup = z.infer<typeof accessGroupSchema>
